import { EntityQuery } from 'breeze-client';
import { Dataset } from '../../models';

const baseQuery = EntityQuery.from('Datasets');
const datasetAccess = baseQuery.expand(Dataset.propName('allowedPrincipals')).orderBy(Dataset.propName('name'));

export const datasetQueries = {
  selectAll: baseQuery,
  selectDatasetAccess: datasetAccess
};
